import Api from '../Api';
import ApexCharts from 'apexcharts'

export default class HashrateChart {
    constructor(chartDiv, coin = 'bch', wallet = '') {
        this.rawData = [];
        this.coin = coin;
        this.wallet = wallet;
        this.chart = new ApexCharts(chartDiv, this.getChartOptions());
        this.chart.render(); 
    }

    async render() {
        try {
            let res = null;
            if (this.wallet) {
                if (this.pool == 'public') {
                    res = await Api.pool.miner.submitsChart(this.coin, this.wallet);
                } else {
                    res = await Api.miner.submitsChart(this.coin, this.wallet);
                }
            } else {
                res = await Api.mine.submitsChart(this.coin);
            }
            
            const startDate = new Date();
            startDate.setHours(startDate.getHours() - 24, 0, 0, 0);
            const endDate = new Date();
            const intervalMillis = 1000 * 60 * 15; // 15 minut w milisekundach

            const fullRange = [];
            for (let date = +startDate; date <= +endDate; date += intervalMillis) {
                fullRange.push(new Date(date));
            }

            const result = fullRange.map(interval => {
                const found = res.find(item => (new Date(item[0])).getTime() === interval.getTime());
                return [
                    interval,
                    found ? found[1] : 0,
                    found ? found[2] : 0
                ];
            });

            this.rawData.splice(0);
            this.rawData.push(...result);
            this.chart.updateOptions(this.getChartOptions());
            this.chart.updateSeries(this.getSeries());
        } catch (error) {
            
        }
    }

    getChartOptions() {
        return {
            chart: {
                zoom: { enabled: false },
                type: 'area',
                height: 240,
                parentHeightOffset: 0,
                toolbar: {
                    show: false
                },
                animations: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            fill: {
                opacity: 0.16,
                type: 'solid'
            },
            stroke: {
                width: 2,
                lineCap: "round",
                curve: "smooth"
            },
            xaxis: {
                labels: {
                    datetimeUTC: false
                },
                tooltip: {
                    enabled: false
                },
                axisBorder: {
                    show: false
                },
                type: 'datetime'
            },
            yaxis: {
                labels: {
                    formatter: function(val, index) {
                        if      (val > 1000000000000000) return Math.round(val / 1000000000000000 * 100) / 100 + 'PH/s';
                        else if (val > 1000000000000) return Math.round(val / 1000000000000 * 100) / 100 + 'TH/s';
                        else if (val > 1000000000) return Math.round(val / 1000000000 * 100) / 100 + 'GH/s';
                        else if (val > 1000000) return Math.round(val / 1000000 * 100) / 100 + 'MH/s';
                        else if (val > 1000) return Math.round(val / 1000 * 100) / 100 + 'KH/s';
                        else return val + 'H/s';
                    }
                }
            },
            tooltip: {
                theme: 'dark',
                x: {
                    format: "HH:mm"
                }
            },
            grid: {
                padding: {
                    top: -20,
                    right: 0,
                    left: -4,
                    bottom: -4
                },
                strokeDashArray: 4
            },
            legend: { show: false },
            labels: this.rawData.map(d => d[0].toISOString()),
            series: []
        }
    }

    getSeries() {
        const rates = [];
        for (let i = 0; i < this.rawData.length; i++) {
            let date = new Date(this.rawData[i][0]);

            if (i == this.rawData.length - 1) date = new Date();
            const work = this.rawData[i][2];

            let timeSec = 15 * 60;
            if (i > 0) timeSec = (date - new Date(this.rawData[i - 1][0])) / 1000;

            const r = Math.round(work * 4294967296 / timeSec);
            rates.push(r);
        }

        return [{
            name: "Hashrate",
            // data: this.rawData.map(d => d[2])
            data: rates
        }];
    }
}